import React, { } from "react";
import Slider from "react-slick";

// Import css files for react-slick carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./scss/HomeMinHeader.scss";
import { Link } from "react-router-dom";
import { useState } from "react";

const MainHeaderCarousel = ({ images, category, nextBtn, prevBtn, smDots, autoplay }) => {
  // carousel next arrow icon on the right position
  const NextArrow = ({ onClick }) => {
    return (
      <div className={`btn nextBtn`} onClick={onClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className='nextArrowIcon'
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeWidth="1.5"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div>
    );
  };
  // carousel previous arrow icon on the left position
  const PrevArrow = ({ onClick }) => {
    return (
      <div className={`btn prevBtn`} onClick={onClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className='prevArrowIcon'
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </div>
    );
  };

  // carousel & effect settings
  const [getIndex, setIndex] = useState('');
  const [getClass, setClass] = useState('false');
  const [getAutoplay, setAutoplay] = useState(true);
  const [getHover, setHover] = useState(false);
  const settings = {
    dots: smDots && true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    autoplay: getAutoplay,
    autoplaySpeed: category === 'man' ? 3000 : 5000,
    speed: category === 'man' ? 1200 : 1500,
    slidesToShow: 1,
    pauseOnHover: true,
    pause: true,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: nextBtn && <NextArrow />,
    prevArrow: prevBtn && <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div id={`mainHeaderCarouselWrapper`} >
      <Slider {...settings} >
        {images.map((data, index) => (
          <div key={index}
            onMouseEnter={() => { setIndex(`${data.id}`); setAutoplay(false); setHover(true) }}
          >
            <div className="d-block  relative">
              <img
                style={{ height: "auto", width: "100%" }}
                className="object-cover"
                src={data.img}
                alt={index}
              />
            </div>
          </div>
        ))
        }
      </Slider >
      <div id="imgHoverText" className={` text-light menImgHover ${getHover && 'd-block'}`}
        onMouseOut={() => { setClass('true'); setAutoplay(true); setHover(false) }}
        onMouseOver={() => { setClass('false'); }}
      >
        <div className="h-100 d-flex flex-column justify-center items-center"
          onMouseEnter={() => { setHover(true) }}
          onMouseOut={() => { setHover(true) }}
          onMouseOver={() => { setHover(true) }}
        >
          <p className="mb-5"
            onMouseEnter={() => { setHover(true) }}
            onMouseOut={() => { setHover(true) }}
            onMouseOver={() => { setHover(true) }}
          >MEN's CASUAL</p>
          <Link to={`/product/${getIndex}`} className="browserLink"
            onMouseEnter={() => { setHover(true) }}
            onMouseOut={() => { setHover(true) }}
            onMouseOver={() => { setHover(true) }}
          >BROWSE</Link>
        </div>
      </div>
      <div className={getClass && getClass === 'true' ? 'imgMouseOut menImgMouseOut' : ''}></div>

    </div >
  );
};

export default MainHeaderCarousel;
